import '../../css/ReportTypeCard.css';

interface ReportTypeCardProps {
    reportKey: string;
    displayName: string;
    isFavorite: boolean;
    onToggleFavorite: (reportKey: string) => void;
    onClick: (reportKey: string) => void;
}

/**
 * Card component for a standard report type.
 * Displays report name, star toggle (filled/unfilled), and kebab menu.
 * Star click toggles favorite; card click navigates to the report.
 *
 * Validates: Requirements 2.3, 3.1, 3.4
 */
export const ReportTypeCard = ({
    reportKey,
    displayName,
    isFavorite,
    onToggleFavorite,
    onClick,
}: ReportTypeCardProps) => {
    const handleStarClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent card click
        onToggleFavorite(reportKey);
    };

    const handleKebabClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent card click
        // Kebab menu actions can be extended later
    };

    return (
        <div
            className="report-type-card"
            onClick={() => onClick(reportKey)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(reportKey);
                }
            }}
            aria-label={`Open ${displayName} report`}
        >
            <span className="report-type-card-name">{displayName}</span>

            <button
                className={`report-type-card-star ${isFavorite ? 'favorited' : ''}`}
                onClick={handleStarClick}
                aria-label={isFavorite ? `Remove ${displayName} from favorites` : `Add ${displayName} to favorites`}
                title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
            >
                {isFavorite ? '★' : '☆'}
            </button>

            <button
                className="report-type-card-kebab"
                onClick={handleKebabClick}
                aria-label={`More options for ${displayName}`}
                title="More options"
            >
                ⋮
            </button>
        </div>
    );
};
